import { render, staticRenderFns } from "../../templates/card/bull-card.pug?vue&type=template&id=519c8c0e&lang=pug&"
import script from "./BullCard.vue?vue&type=script&lang=js&"
export * from "./BullCard.vue?vue&type=script&lang=js&"
import style0 from "./BullCard.vue?vue&type=style&index=0&id=519c8c0e&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports